import { getSizeFilterConfig } from '../filters/size';
import { getDefaultShopConfig, getDefaultTradeInShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { Conditions, getConditionsFilterConfig } from '../filters/condition';
import { MediaPayload } from '../configHelper';

const ettitudeSizeOptions = [
  'XS',
  'S',
  'S/M',
  'M',
  'L',
  'L/XL',
  'XL',
  'XXL',
  'Crib',
  'Twin',
  'Twin XL',
  'Standard',
  'Full',
  'Full/Queen',
  'Queen',
  'King',
  'King/Cal King',
  'Cal King',
  'One Size',
  'Hand Towel',
  'Bath Towel',
  'Bath Sheet',
];

const ettitudeAdditionalPayoutSettings = {
  additionalShopifyDiscountCodeRequirements: {
    // TODO extract into a fragment
    mutation: { minimumRequirement: { subtotal: { greaterThanOrEqualToSubtotal: '200.00' } } },
  },
  creditCodeHelperText:
    'Code can only be used on ettitude.com for purchases over $200. Limit one code per checkout.',
  tradeInCreditPayoutBundleAmount: 5000,
};

const ettitudeConditions = [
  {
    key: Conditions.NewWithTags,
    label: 'New With Packaging',
    description:
      'Your item has never been used or worn and is still in the original packaging with hangtags.',
  },
  {
    key: Conditions.Excellent,
    label: 'Excellent Condition',
    description: 'Your item has only been lightly used and has been extremely well maintained.',
  },
  {
    key: Conditions.Good,
    label: 'Well Loved',
    description:
      'The item has been used frequently. It may have a small quirk like a button missing, or a loose thread.',
  },
];

const getMediaForVariant = (
  media?: MediaPayload[],
  selectedVariantOptions?: Record<string, string | null>
) => {
  if (!media || !selectedVariantOptions) return media || [];

  const color = selectedVariantOptions.Color || selectedVariantOptions.color;
  if (!color) return media;

  const colorFilteredImages = media.filter((mediaItem) => mediaItem.alt?.startsWith(color));

  // Return color-filtered images if found, otherwise return all media
  return colorFilteredImages.length > 0 ? colorFilteredImages : media;
};

export const ettitudeShopConfig = {
  ...getDefaultShopConfig(),
  ...getDefaultTradeInShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig({ options: ettitudeConditions }),
    getSizeFilterConfig({ sizes: ettitudeSizeOptions }),
  ],
  additionalPayoutSettings: ettitudeAdditionalPayoutSettings,
  getMediaForVariant,
};
